"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginFromRequest = void 0;
function getOriginFromRequest(req) {
    var host = req.headers.host;
    var protocol = /^localhost(:\d+)?$/.test(host) ? 'http:' : 'https:';
    if (req.headers['x-forwarded-host'] &&
        typeof req.headers['x-forwarded-host'] === 'string') {
        host = req.headers['x-forwarded-host'];
    }
    if (req.headers['x-forwarded-proto'] &&
        typeof req.headers['x-forwarded-proto'] === 'string') {
        protocol = "".concat(req.headers['x-forwarded-proto'], ":");
    }
    return "".concat(protocol, "//").concat(host);
}
exports.getOriginFromRequest = getOriginFromRequest;
exports.default = getOriginFromRequest;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0T3JpZ2luRnJvbVJlcXVlc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0T3JpZ2luRnJvbVJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsU0FBZ0Isb0JBQW9CLENBQUMsR0FBb0I7SUFDdkQsSUFBSSxJQUFJLEdBQUcsR0FBRyxDQUFDLE9BQU8sQ0FBQyxJQUFjLENBQUM7SUFDdEMsSUFBSSxRQUFRLEdBQUcsb0JBQW9CLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQztJQUVwRSxJQUNFLEdBQUcsQ0FBQyxPQUFPLENBQUMsa0JBQWtCLENBQUM7UUFDL0IsT0FBTyxHQUFHLENBQUMsT0FBTyxDQUFDLGtCQUFrQixDQUFDLEtBQUssUUFBUSxFQUNuRCxDQUFDO1FBQ0QsSUFBSSxHQUFHLEdBQUcsQ0FBQyxPQUFPLENBQUMsa0JBQWtCLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQsSUFDRSxHQUFHLENBQUMsT0FBTyxDQUFDLG1CQUFtQixDQUFDO1FBQ2hDLE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQyxtQkFBbUIsQ0FBQyxLQUFLLFFBQVEsRUFDcEQsQ0FBQztRQUNELFFBQVEsR0FBRyxVQUFHLEdBQUcsQ0FBQyxPQUFPLENBQUMsbUJBQW1CLENBQUMsTUFBRyxDQUFDO0lBQ3BELENBQUM7SUFFRCxPQUFPLFVBQUcsUUFBUSxlQUFLLElBQUksQ0FBRSxDQUFDO0FBQ2hDLENBQUM7QUFuQkQsb0RBbUJDO0FBQ0Qsa0JBQWUsb0JBQW9CLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/auth-redirect-router/getOriginFromRequest.js
// module id = 4425
// module chunks = 25